import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'
import ReactSwitch from 'react-switch'
import ModalAlert from 'components/ModalAlert'
/**
 * Switch
 * @param {object} props
 * @param {string} props.id
 * @param {string} props.name
 * @param {string} props.label
 * @param {boolean} props.defaultChecked
 * @param {Function} props.onChange
 * @param {boolean} props.disabled
 */
const Switch = (props) => {
  const { id, propName, label, defaultChecked, onChange, disabled } = props
  const [modalAlertPost, setModalAlertPost] = useState(false)

  const onChangeIsPost = (value)=>{
    if(propName === 'value_isPost' && value && id.slice(0,3)!== 'new')
      setModalAlertPost(value)
    onChange(value)
  }
  return (
    <div className='channel-field switch'>
      <ReactSwitch
        id={id}
        name={propName}
        checked={defaultChecked}
        onChange={(value) => onChangeIsPost(value)}
        disabled={disabled}
        onColor='#E87721'
        uncheckedIcon={false}
        checkedIcon={false}
        onHandleColor='#fff'
      />
      {label && <label>{I18n.t(label)}</label>}
      <ModalAlert
        isOpen={modalAlertPost}
        toggle={() => {
          setModalAlertPost(!modalAlertPost)
        }}
        header={I18n.t('dashboard_activate-posts')}
        text1={I18n.t('warning_text1_switch_is_post')}
        text2={I18n.t('warning_text2_switch_is_post')}
      />
    </div>
  )
}

export default Switch
